import React, { useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import emailjs from '@emailjs/browser';
import { tours, activities } from '../data';
import './Booking.css';

const itemImages = {
  'atlas-mountains-day-trip':      'https://www.image2url.com/r2/default/images/1776889060236-37d4350c-4b74-4ad9-a6f2-2eb4d3930966.jpg',
  'agafay-desert-day-trip':        'https://images.unsplash.com/photo-1509316785289-025f5b846b35?w=600&q=80',
  'ouzoud-waterfalls-trip':        'https://www.image2url.com/r2/default/images/1776889330860-491f6402-d23c-4714-80b8-2b5485c43d64.jpg',
  'ait-ben-haddou-kasbah':         'https://images.unsplash.com/photo-1737927427538-9f9b4ea4ab02?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'essaouira-day-trip':            'https://images.unsplash.com/photo-1624802704371-c76faa34c3a0?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'ourika-valley-day-trip':        'https://images.unsplash.com/photo-1671804079626-4aaafa95184e?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'marrakech-medina-guided-tour':  'https://images.unsplash.com/photo-1597212618440-806262de4f6b?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'marrakech-food-tour':           'https://images.unsplash.com/photo-1643019237176-8ae0859f1123?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'marrakech-casablanca-day-trip': 'https://images.unsplash.com/photo-1701945247920-7e4a461e08cb?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'lake-takerkoust-asni-valley':   'https://www.image2url.com/r2/default/images/1776890677648-dad65ab7-ede1-4a42-8cb7-7b860349c01b.webp',
  'marrakech-photography-tour':    'https://images.unsplash.com/photo-1554048612-b6a482bc67e5?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'shopping-in-the-souks':         'https://images.unsplash.com/photo-1587974928442-77dc3e0dba72?w=600&q=80',
  'hot-air-balloon-marrakech':     'https://images.unsplash.com/photo-1549740425-5e9ed4d8cd34?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'camel-ride-palmeraie':          'https://images.unsplash.com/photo-1640328504956-e6fb38ff8934?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'camel-ride-agafay':             'https://images.unsplash.com/photo-1509316785289-025f5b846b35?w=600&q=80',
  'quad-palmeraie':                'https://images.unsplash.com/photo-1627760444690-59f0a5fccee6?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'quad-agafay':                   'https://images.unsplash.com/photo-1624062999803-976e1adc8ea2?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'buggy-agafay':                  'https://images.unsplash.com/photo-1635350644558-0f12a6a88cbd?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'horseback-riding-lake-takerkoust': 'https://images.unsplash.com/photo-1633767979501-6225d151ba70?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'marrakech-cooking-class':       'https://images.unsplash.com/photo-1565557623262-b51c2513a641?w=600&q=80',
  'pottery-class-marrakech':       'https://images.unsplash.com/photo-1612950662573-546117a61e78?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'sidecar-tour-marrakech':        'https://www.image2url.com/r2/default/images/1776895483967-ebd12bf7-9ca3-4d7a-b494-dc16d81b6024.webp',
  'marrakech-hammam-spa':          'https://images.unsplash.com/photo-1714648775497-9f54f75eb3ea?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'marrakech-agadir-day-trip':     'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=800&q=80',
  'yoga-marrakech':                'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=800&q=80',
};

const EMAILJS_SERVICE         = 'service_0jia24m';
const EMAILJS_TEMPLATE        = 'template_va2wn68';
const EMAILJS_TEMPLATE_CLIENT = 'template_rzhp0ki';
const EMAILJS_KEY             = 'SpCTyhB53am0B5sAU';

export default function Booking() {
  const [searchParams] = useSearchParams();
  const tourSlug = searchParams.get('tour');
  const activitySlug = searchParams.get('activity');
  const initAdults = parseInt(searchParams.get('adults') || '2');
  const initChildren = parseInt(searchParams.get('children') || '0');
  const initDate = searchParams.get('date') || '';

  const item = tourSlug
    ? tours.find(t => t.slug === tourSlug)
    : activitySlug
    ? activities.find(a => a.slug === activitySlug)
    : null;

  const [step, setStep] = useState(1);
  const [adults, setAdults] = useState(initAdults);
  const [children, setChildren] = useState(initChildren);
  const [date, setDate] = useState(initDate);
  const [selectedItem, setSelectedItem] = useState(item);
  const [form, setForm] = useState({ firstName: '', lastName: '', email: '', phone: '', country: '', hotel: '', requests: '', terms: false });
  const [confirmed, setConfirmed] = useState(false);
  const [sending, setSending] = useState(false);
  const [sendError, setSendError] = useState('');

  const price = selectedItem ? ((adults * selectedItem.price) + (children * (selectedItem.priceChild || 0))) : 0;
  const [bookingRef] = useState('MT-' + Math.random().toString(36).substr(2, 7).toUpperCase());

  const emailSubject = `New Booking Request — ${selectedItem?.name || 'Tour'} [${bookingRef}]`;
  const emailBody = [
    `BOOKING REQUEST — ${bookingRef}`,
    ``,
    `━━━ SERVICE ━━━`,
    `Tour / Activity : ${selectedItem?.name || 'N/A'}`,
    `Duration        : ${selectedItem?.duration || 'N/A'}`,
    `Date            : ${date || 'TBC'}`,
    `Adults          : ${adults}`,
    `Children        : ${children}`,
    `Total Price     : To be confirmed`,
    ``,
    `━━━ CUSTOMER DETAILS ━━━`,
    `Full Name       : ${form.firstName} ${form.lastName}`,
    `Email           : ${form.email}`,
    `Phone / WhatsApp: ${form.phone}`,
    `Country         : ${form.country || 'N/A'}`,
    `Hotel (pickup)  : ${form.hotel || 'N/A'}`,
    `Special Requests: ${form.requests || 'None'}`,
  ].join('\n');

  const waText = [
    `🌍 *NEW BOOKING REQUEST* — ${bookingRef}`,
    ``,
    `📋 *SERVICE*`,
    `• Tour: ${selectedItem?.name || 'N/A'}`,
    `• Duration: ${selectedItem?.duration || 'N/A'}`,
    `• Date: ${date || 'TBC'}`,
    `• Adults: ${adults}`,
    `• Children: ${children}`,
    `• Total: To be confirmed`,
    ``,
    `👤 *CUSTOMER DETAILS*`,
    `• Name: ${form.firstName} ${form.lastName}`,
    `• Email: ${form.email}`,
    `• Phone: ${form.phone}`,
    `• Country: ${form.country || 'N/A'}`,
    `• Hotel (pickup): ${form.hotel || 'N/A'}`,
    form.requests ? `• Special Requests: ${form.requests}` : null,
  ].filter(Boolean).join('\n');

  const handleEmailSend = async (e) => {
    e.preventDefault();
    if (!form.terms) return;
    setSending(true);
    setSendError('');
    try {
      await emailjs.send(
        EMAILJS_SERVICE,
        EMAILJS_TEMPLATE,
        {
          subject: `New Booking Request — ${selectedItem?.name || 'Tour'} [${bookingRef}]`,
          message: emailBody,
        },
        EMAILJS_KEY
      );

      await emailjs.send(
        EMAILJS_SERVICE,
        EMAILJS_TEMPLATE_CLIENT,
        {
          customer_name:  `${form.firstName} ${form.lastName}`,
          customer_email: form.email,
          tour_name:      selectedItem?.name || 'N/A',
          date:           date || 'TBC',
          adults:         adults,
          total_price:    'To be confirmed',
          booking_ref:    bookingRef,
        },
        EMAILJS_KEY
      );

      setConfirmed(true);
    } catch (err) {
      setSendError('Failed to send. Please try WhatsApp or contact us directly.');
    } finally {
      setSending(false);
    }
  };

  const handleWhatsApp = () => {
    if (!form.terms) return;
    setConfirmed(true);
  };

  if (confirmed) {
    return (
      <div className="booking-confirmed">
        <div className="confirmed-card">
          <div className="confirmed-icon">✓</div>
          <h1 className="confirmed-title">Booking Confirmed!</h1>
          <div className="confirmed-ref">Booking ref: <strong>{bookingRef}</strong></div>
          <p className="confirmed-sub">Your booking request has been sent. We will contact you shortly to confirm your reservation.</p>
          {selectedItem && (
            <div className="confirmed-summary">
              <div className="confirmed-row"><span>Tour</span><span>{selectedItem.name}</span></div>
              <div className="confirmed-row"><span>Date</span><span>{date || 'TBC'}</span></div>
              <div className="confirmed-row"><span>Travelers</span><span>{adults} adults{children > 0 ? `, ${children} children` : ''}</span></div>
              <div className="confirmed-row total"><span>Price</span><span>To be confirmed</span></div>
            </div>
          )}
          <div className="confirmed-actions">
            <a
              href={`https://wa.me/212694401220?text=Hi!%20My%20booking%20ref%20is%20${bookingRef}.%20Looking%20forward%20to%20the%20tour!`}
              target="_blank" rel="noreferrer"
              className="btn"
              style={{ background: '#25d366', color: '#fff' }}
            >
              Message Guide on WhatsApp
            </a>
            <Link to="/tours" className="btn btn-ghost">Explore More Tours</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="page-hero" style={{ padding: '80px 0 40px' }}>
        <div className="container">
          <div className="section-tag">Secure Booking</div>
          <h1>Book Your Experience</h1>
        </div>
      </div>

      <section className="section section-white" style={{ paddingTop: 40 }}>
        <div className="container booking-layout" style={!selectedItem ? { gridTemplateColumns: '1fr' } : {}}>

          <div className="booking-steps-col">
            <div className="step-indicator">
              {[1, 2, 3].map((s, i) => (
                <React.Fragment key={s}>
                  <div className={`step-item${step >= s ? ' active' : ''}${step > s ? ' done' : ''}`}>
                    <div className="step-circle">
                      {step > s ? (
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
                      ) : s}
                    </div>
                    <span className="step-label">
                      {s === 1 ? 'Select' : s === 2 ? 'Details' : 'Confirm'}
                    </span>
                  </div>
                  {i < 2 && <div className={`step-line${step > s ? ' done' : ''}`} />}
                </React.Fragment>
              ))}
            </div>

            {step === 1 && (
              <div className={!selectedItem ? '' : 'booking-step-panel'}>
                <h2 className="booking-step-title">Select Your Experience</h2>

                {!selectedItem ? (
                  <div>
                    <p style={{ color: 'var(--muted)', marginBottom: 20, fontSize: 14 }}>Choose a tour or activity to book:</p>
                    <div className="booking-cards-grid">
                      {[...tours, ...activities].map(t => (
                        <button
                          key={t.slug}
                          className="booking-card-item"
                          onClick={() => setSelectedItem(t)}
                        >
                          <div className="booking-card-item__img">
                            {itemImages[t.slug]
                              ? <img src={itemImages[t.slug]} alt={t.name} loading="lazy" />
                              : <div style={{ background: `linear-gradient(135deg, ${t.bgColor}, #1a1a2e)`, width: '100%', height: '100%' }} />
                            }
                            <div className="booking-card-item__overlay" />
                            {t.badge && <span className="booking-card-item__badge">{t.badge}</span>}
                          </div>
                          <div className="booking-card-item__body">
                            <div className="booking-card-item__name">{t.name}</div>
                            <div className="booking-card-item__meta">
                              <span>⏱ {t.duration}</span>
                              {t.rating && <span>★ {t.rating}</span>}
                            </div>
                          </div>
                        </button>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="selected-item">
                      <div style={{ width: 44, height: 44, borderRadius: 8, background: `linear-gradient(135deg, ${selectedItem.bgColor}, #1a1a2e)`, flexShrink: 0 }} />
                      <div>
                        <div className="selected-item__name">{selectedItem.name}</div>
                        <div className="selected-item__meta">{selectedItem.duration}</div>
                      </div>
                      <button className="selected-item__change" onClick={() => setSelectedItem(null)}>Change</button>
                    </div>

                    <div className="booking-field" style={{ marginTop: 24 }}>
                      <label>Date *</label>
                      <input type="date" value={date} onChange={e => setDate(e.target.value)} min={new Date().toISOString().split('T')[0]} required />
                    </div>

                    <div className="booking-field">
                      <label>Adults</label>
                      <div className="counter">
                        <button type="button" onClick={() => setAdults(Math.max(1, adults - 1))}>−</button>
                        <span>{adults}</span>
                        <button type="button" onClick={() => setAdults(adults + 1)}>+</button>
                      </div>
                    </div>

                    {selectedItem.priceChild != null && (
                      <div className="booking-field">
                        <label>Children (under 12) — €{selectedItem.priceChild} each</label>
                        <div className="counter">
                          <button type="button" onClick={() => setChildren(Math.max(0, children - 1))}>−</button>
                          <span>{children}</span>
                          <button type="button" onClick={() => setChildren(children + 1)}>+</button>
                        </div>
                      </div>
                    )}

                    <button
                      className="btn btn-primary"
                      style={{ width: '100%', marginTop: 24, padding: 14, justifyContent: 'center' }}
                      onClick={() => date && setStep(2)}
                      disabled={!date}
                    >
                      Continue to Details →
                    </button>
                  </div>
                )}
              </div>
            )}

            {step === 2 && (
              <div className="booking-step-panel">
                <h2 className="booking-step-title">Your Details</h2>
                <div className="contact-form">
                  <div className="form-row">
                    <div className="form-field">
                      <label>First Name *</label>
                      <input type="text" required value={form.firstName} onChange={e => setForm({ ...form, firstName: e.target.value })} />
                    </div>
                    <div className="form-field">
                      <label>Last Name *</label>
                      <input type="text" required value={form.lastName} onChange={e => setForm({ ...form, lastName: e.target.value })} />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-field">
                      <label>Email *</label>
                      <input type="email" required value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
                    </div>
                    <div className="form-field">
                      <label>Phone / WhatsApp *</label>
                      <input type="tel" required value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-field">
                      <label>Country</label>
                      <input type="text" placeholder="United Kingdom" value={form.country} onChange={e => setForm({ ...form, country: e.target.value })} />
                    </div>
                    <div className="form-field">
                      <label>Hotel Name (for pickup)</label>
                      <input type="text" placeholder="Your hotel in Marrakech" value={form.hotel} onChange={e => setForm({ ...form, hotel: e.target.value })} />
                    </div>
                  </div>
                  <div className="form-field">
                    <label>Special Requests</label>
                    <textarea rows={3} placeholder="Dietary requirements, accessibility needs, etc." value={form.requests} onChange={e => setForm({ ...form, requests: e.target.value })} />
                  </div>
                  <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
                    <button className="btn btn-ghost" onClick={() => setStep(1)}>← Back</button>
                    <button
                      className="btn btn-primary"
                      style={{ flex: 1, justifyContent: 'center', padding: 14 }}
                      onClick={() => form.firstName && form.email && form.phone && setStep(3)}
                      disabled={!form.firstName || !form.email || !form.phone}
                    >
                      Review & Confirm →
                    </button>
                  </div>
                </div>
              </div>
            )}

            {step === 3 && (
              <div className="booking-step-panel">
                <h2 className="booking-step-title">Confirm Your Booking</h2>

                <p style={{ fontSize: 14, color: 'var(--muted)', marginBottom: 24 }}>
                  Please review your details below, then choose how you'd like to send your booking request to us.
                </p>

                <div className="booking-review">
                  <div className="booking-review__row"><span>Ref</span><span style={{fontWeight:700, color:'var(--primary)'}}>{bookingRef}</span></div>
                  <div className="booking-review__row"><span>Tour / Activity</span><span>{selectedItem?.name}</span></div>
                  <div className="booking-review__row"><span>Date</span><span>{date || 'TBC'}</span></div>
                  <div className="booking-review__row"><span>Travelers</span><span>{adults} adults{children > 0 ? `, ${children} children` : ''}</span></div>
                  <div className="booking-review__row"><span>Name</span><span>{form.firstName} {form.lastName}</span></div>
                  <div className="booking-review__row"><span>Email</span><span>{form.email}</span></div>
                  <div className="booking-review__row"><span>Phone</span><span>{form.phone}</span></div>
                  {form.country && <div className="booking-review__row"><span>Country</span><span>{form.country}</span></div>}
                  {form.hotel && <div className="booking-review__row"><span>Hotel (pickup)</span><span>{form.hotel}</span></div>}
                  {form.requests && <div className="booking-review__row"><span>Special Requests</span><span>{form.requests}</span></div>}
                  <div className="booking-review__row total"><span>Price</span><span>To be confirmed</span></div>
                </div>

                <div className="terms-check" style={{ marginBottom: 24 }}>
                  <input type="checkbox" id="terms" required checked={form.terms} onChange={e => setForm({ ...form, terms: e.target.checked })} />
                  <label htmlFor="terms">I agree to the <a href="/terms" target="_blank">Terms & Conditions</a> and <a href="/privacy" target="_blank">Privacy Policy</a></label>
                </div>

                {sendError && (
                  <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: 8, padding: '12px 16px', marginBottom: 16, fontSize: 13, color: '#991b1b' }}>
                    {sendError}
                  </div>
                )}

                <div className="send-options">
                  <button
                    onClick={handleEmailSend}
                    disabled={!form.terms || sending}
                    className={`send-option-btn send-option-btn--email${!form.terms || sending ? ' disabled' : ''}`}
                  >
                    {sending
                      ? <div style={{ width: 22, height: 22, border: '2px solid #4f6ef7', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 0.7s linear infinite' }} />
                      : <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>
                    }
                    <div>
                      <div className="send-option-btn__title">{sending ? 'Sending...' : 'Send via Email'}</div>
                      <div className="send-option-btn__sub">Delivered directly to our inbox</div>
                    </div>
                  </button>

                  <a
                    href={form.terms ? `https://wa.me/212694401220?text=${encodeURIComponent(waText)}` : undefined}
                    target="_blank" rel="noreferrer"
                    onClick={() => form.terms && handleWhatsApp()}
                    className={`send-option-btn send-option-btn--wa${!form.terms ? ' disabled' : ''}`}
                  >
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12 0C5.373 0 0 5.373 0 12c0 2.123.553 4.116 1.522 5.852L0 24l6.313-1.492A11.954 11.954 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.818 9.818 0 01-5.006-1.37l-.36-.213-3.736.882.935-3.626-.234-.372A9.818 9.818 0 1112 21.818z"/></svg>
                    <div>
                      <div className="send-option-btn__title">Send via WhatsApp</div>
                      <div className="send-option-btn__sub">+212 614 692 812</div>
                    </div>
                  </a>
                </div>

                <button type="button" className="btn btn-ghost" style={{ marginTop: 16 }} onClick={() => setStep(2)}>← Back</button>
              </div>
            )}
          </div>

          {selectedItem && (
            <div className="booking-summary-col">
              <div className="booking-summary">
                <h3 className="booking-summary__title">Order Summary</h3>
                <div className="booking-summary__item">
                  <div style={{ width: 40, height: 40, borderRadius: 8, background: `linear-gradient(135deg, ${selectedItem.bgColor}, #1a1a2e)`, flexShrink: 0 }} />
                  <div>
                    <div className="booking-summary__name">{selectedItem.name}</div>
                    <div className="booking-summary__meta">{date || 'Date TBC'} · {selectedItem.duration}</div>
                  </div>
                </div>
                <div className="booking-summary__lines">
                  <div className="booking-summary__line"><span>Adults</span><span>{adults}</span></div>
                  {children > 0 && <div className="booking-summary__line"><span>Children</span><span>{children}</span></div>}
                  <div className="booking-summary__line total"><span>Price</span><span style={{fontSize:14}}>On request</span></div>
                </div>
                <div className="booking-summary__features">
                  <div>✓ Free cancellation up to 48h</div>
                  <div>✓ Hotel pickup included</div>
                  <div>✓ Instant confirmation</div>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
